import { Component, inject, model, OnInit, signal, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {
  WorkDocument,
  WorkDocumentsV2Service,
  WorkDocumenttypeIdentifierNameEnum,
  WorkProject,
} from '@work-frontend-monorepo/work-rest-api';
import { FormatDatePipe } from '@work-frontend-monorepo/work-ui/pipes';
import { ModalComponent } from '@work-frontend-monorepo/work-ui/modals';
import { DokumenteViewerComponent } from '@work-frontend-monorepo/work-ui/documents';
import { TableBaseClass, TableHeaderItem, TableHeadersComponent } from '@work-frontend-monorepo/work-ui/tables';
import { ExceptionHandlingService } from '@work-frontend-monorepo/work-ui/services';

@Component({
  selector: 'sfg-app-projekte-dokumente',
  standalone: true,
  imports: [
    CommonModule,
    FormatDatePipe,
    TranslateModule,
    TableHeadersComponent,
    FormsModule,
    TableHeadersComponent,
    FormatDatePipe,
    ModalComponent,
    DokumenteViewerComponent,
  ],
  templateUrl: './projekte-dokumente.component.html',
  styleUrl: './projekte-dokumente.component.scss',
})
export class ProjekteDokumenteComponent extends TableBaseClass<WorkDocument> implements OnInit {
  public project = model.required<WorkProject>();

  public activeDocument = signal<WorkDocument | undefined>(undefined);
  public projektDokumenteViewerModal = viewChild<ModalComponent>('projektDokumenteViewerModal');

  public override tableHeaderItems: TableHeaderItem[] = [
    {
      label: 'DOKUMENTENTYP',
      sortable: false,
      name: 'documenttype.name',
    },
  ];
  private readonly documentsV2Service = inject(WorkDocumentsV2Service);
  private readonly exceptionHandlingService = inject(ExceptionHandlingService);

  async ngOnInit() {
    await this.load();
  }

  public override async load() {
    try {
      this.dataPaginated = await lastValueFrom(
        this.documentsV2Service.documentsV2ControllerFindAllPaginated({
          limit: 50,
          page: this.getPage(),
          sortBy: this.getSortBy(),
          'filter.projectId': [`${this.project().id}`],
          'filter.documenttype.identifierName': [
            `$not:${WorkDocumenttypeIdentifierNameEnum.Projektfoto}`,
            `$not:${WorkDocumenttypeIdentifierNameEnum.ProjektTitelbild}`,
            `$not:${WorkDocumenttypeIdentifierNameEnum.Kreditor}`,
            `$or:$null`,
          ],
        }),
      );
    } catch (documentLoadException) {
      this.exceptionHandlingService.handleExceptionWithAlert('documentLoadException', documentLoadException);
    }
  }

  public openDocument(document: WorkDocument) {
    this.activeDocument.set(document);
    this.projektDokumenteViewerModal()?.open();
  }
}
